import { Container } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProviderCard from "../../components/cards/ProviderCard";
import CardSkeleton from "../../components/skeletons/workerCardSkeleton";
import { fetchWorker } from "../../lib/redux/slices/workerSlice";
import useDebounce from "./../../components/hooks/useDebounce";

const AllWorkers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userReducer.user);
  const subServiceId = useSelector(
    (state) => state.activeSubServiceIdReducer.subServiceId
  );
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
  const decounceRatingTerm = useDebounce(searchKeys?.workerRating, 1000);
  const decounceNameTerm = useDebounce(searchKeys?.workerName, 1000);
  const { data, isLoading, error } = useSelector(
    (state) => state.workerReducer
  );

  console.log(userData, "userDatauserDatauserDatauserData");

  useEffect(() => {
    if (subServiceId) {
      console.log("subServiceId", subServiceId);
      let lat = searchKeys?.workerLocation?.latitude || "";
      let lng = searchKeys?.workerLocation?.longitude || "";

      const query = {
        serviceId: subServiceId,
        lat: lat,
        lng: lng,
        name: searchKeys?.workerName || "",
        rating: searchKeys?.workerRating || "",
        date: searchKeys.workerDateTime || "",
        ...(userData?.createdBy && { companyId: userData?.createdBy }),
      };

      dispatch(fetchWorker(query));
    }
  }, [subServiceId, decounceNameTerm, decounceRatingTerm]);

  const handleClickOnCard = (data) => {
    navigate(`/worker-detail/${data?._id}?service=${subServiceId}`);
  };

  return (
    <Container sx={{ my: 6 }}>
      {isLoading ? (
        <Grid container spacing={2} mt={2}>
          {[...Array(4)].map((_, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }}>
              <CardSkeleton />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={2} mt={2}>
          {isLoading === false &&
            data?.map((val, index) => {
              return (
                <Grid key={val._id} size={{ xs: 12, sm: 4, md: 3 }}>
                  <ProviderCard
                    data={val}
                    index={index}
                    handleClickOnCard={handleClickOnCard}
                  />
                </Grid>
              );
            })}
        </Grid>
      )}
    </Container>
  );
};

export default AllWorkers;
